module.exports = __webpack_public_path__ + "6dd4c52a7e3daa77436091fb6b3727bc.jpg";